<template>
    <div class="modal-dialog"
         v-bind:class="{visible: visible}"
    >

        <div class="content">
            <throbber-overlay v-if="busy"></throbber-overlay>

            <div v-html="content" v-show="content && typeof content === 'string'"></div>
            <div v-show="content && typeof content === 'object'" class="dialog-object-container"></div>

            <div class="actions" v-if="content">
                <button class="button float-sm-left" v-on:click="cancel" v-if="cancelButtonVisible">{{ cancelLabel }}</button>
                <button class="button" v-on:click="confirm">{{ okLabel }}</button>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .modal-dialog {
        pointer-events: all;
        position: fixed;
        top: 0;
        right: 90%;
        bottom: 90%;
        left: 0;
        z-index: 100000;
        max-width: 100%;
        margin: 0;
        overflow: hidden;
        opacity: 0;

        margin-left: -500%;
        margin-top: -500%;

        background: rgba(0, 0, 0, 0.2);
        backdrop-filter: blur(0);

        transition: opacity, backdrop-filter;
        transition-duration: 0.3s;
        transition-timing-function: ease-in-out;

        .content {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -48%);
            zoom: 0.6;

            min-width: 300px;
            /*max-width: 50vw;*/
            /*max-height: 60vh;*/
            max-height: 80vh;
            overflow: auto;

            background: white;

            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
            padding: 1rem;

            transition: transform, zoom;
            transition-duration: 0.3s;
            transition-timing-function: ease-in-out;

            .actions {
                margin-top: 1rem;
                text-align: right;
            }
        }

        &.visible {
            margin: 0;
            right: 0;
            bottom: 0;
            opacity: 1;
            backdrop-filter: blur(1px);

            .content {
                zoom: 1;
                transform: translate(-50%, -50%);
            }
        }
    }
</style>


<script>
    const ThrobberOverlay = require('./booking/ThrobberOverlay').default;

    const events = {
        opened: 'modal-dialog:opened',
        closed: 'modal-dialog:closed',
    };

    //@todo Refactor all these _dispatchDomEvents used throughout to something in Utils?
    function _dispatchDomEvent($el, eventName, data = null) {
        let eventData = data === null
            ? {}
            : {detail: data};

        eventData.bubbles = true;

        let event;

        /*event = data === null
            ? new Event(eventName, eventData)
            : new CustomEvent(eventName, eventData);*/
        event = new CustomEvent(eventName, eventData);

        $el.dispatchEvent(event);
    }

    const noop = () => {};

    export default {
        components: {
            ThrobberOverlay,
        },
        props: {},
        data: () => {
            return {
                busy: false,
                visible: false,
                content: [],
                objectContentContainer: null,
                cancelButtonVisible: false,
                statePromise: null,
                preConfirmCallback: null,
                showCallback: null,
                hideCallback: null,
                cancelLabel: 'CANCEL',
                okLabel: 'OK'
            }
        },
        computed: {},
        mounted() {
            this.objectContentContainer = this.$el.querySelector('.dialog-object-container');
        },
        methods: {
            setVisible: function (visible = true) {
                this.visible = visible;

                if (this.statePromise && visible) {
                    this.statePromise._reject('Dialog was already visible');
                    this.statePromise = null;
                }

                if (visible) {
                    let _resolve, _reject;
                    this.statePromise = new Promise((resolve, reject) => {
                        _resolve = resolve;
                        _reject = reject;
                    });
                    //make these callable from elsewhere
                    this.statePromise._resolve = _resolve;
                    this.statePromise._reject = _reject;

                    _dispatchDomEvent(this.$el, events.opened, {
                        promise: this.statePromise
                    });

                    if (this.showCallback) {
                        this.showCallback();
                    }
                }
                else {
                    this.statePromise = null;
                }


                return this.statePromise;
            },
            setContent: function (content, show = true) {

                if (show) {
                    this.setVisible();
                }

                if (typeof content === 'object' && content.then) {
                    this.busy = true;
                    this.content = false;
                    content.then(result => {
                        this.content = result
                    }).finally(() => this.busy = false);
                }
                else if (typeof content === 'object' && content.parentNode) {
                    content._originalParent = content.parentNode;
                    content._nextSibling = content.nextSibling;
                    while (this.objectContentContainer.firstChild) {
                        this.objectContentContainer.firstChild.remove();
                    }
                    this.objectContentContainer.append(content);
                    this.content = content;
                }
                else {
                    this.content = content;
                }

                if (show) {
                    return this.statePromise;
                }
            },
            setPreConfirmCallback: function(callback) {
                this.preConfirmCallback = callback;
            },
            setShowCallback: function(callback) {
                if (typeof callback !== 'function') {
                    throw 'Callback must be a function';
                }
                this.showCallback = callback;
            },
            setHideCallback: function(callback) {
                if (typeof callback !== 'function') {
                    throw 'Callback must be a function';
                }
                this.hideCallback = callback;
            },
            showCancel: function (show = true) {
                this.cancelButtonVisible = show ? true : false;
            },
            setCancelLabel: function (cancelLabel) {
                this.cancelLabel = cancelLabel;
            },
            setOkLabel: function (okLabel) {
              this.okLabel = okLabel;
            },
            close: function () {
                this.setVisible(false);
                if (typeof this.content === 'object' && this.content.parentNode) {
                    window.setTimeout(() => {
                        this.content._originalParent.insertBefore(this.content, this.content._nextSibling);
                        delete (this.content._originalParent);
                        delete (this.content._nextSibling);
                    }, 10);
                }
                _dispatchDomEvent(this.$el, events.closed, { });

                if (this.hideCallback) {
                    this.hideCallback();
                }
            },
            confirm: function() {
                if (!this.statePromise) {
                    throw 'No promise object was found?';
                }

                if (typeof this.preConfirmCallback === 'function' && !this.preConfirmCallback()) {
                    return;
                }

                this.statePromise._resolve('Confirmed');
                this.close();
            },
            cancel: function() {
                if (!this.statePromise) {
                    throw 'No promise object was found?';
                }
                this.statePromise._reject('Cancelled');
                this.close();
            },
        }
    }
</script>
